import 'milligram';
import './index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { init } from '@emailjs/browser';

init({
  publicKey: 'DMrytKvXkR2qukZ2_',
  // Do not allow headless browsers
  blockHeadless: true,
  limitRate: {
    // Set the limit rate for the application
    id: 'app',
    // Allow 1 request per 10s
    throttle: 10000,
  },
});

const root = createRoot(document.getElementById('root'));
root.render(<App />);